import React from "react";
import styles from "./ClarionWaitlist.module.css";

function Header() {
  return (
    <header className={styles.header}>
      <h1>DeepBox</h1>
    </header>
  );
}

export default Header;